import { mergeMap } from 'rxjs/operators';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RoutingRuleAction } from '../routingRule.action';
import { RoutingRuleTranslator } from '../routingRule.translator';

type IDependencies = IClientApiDependencySegment;

export const loadRoutingRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(RoutingRuleAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getRoutingRules().pipe(
      mergeMap((response) => {
        const result = (response.rules ?? []).map(RoutingRuleTranslator.fromApi);

        return [
          RoutingRuleAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          RoutingRuleAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
